import { render, staticRenderFns } from "./DropFiles.vue?vue&type=template&id=88fb3e44&scoped=true"
import script from "./DropFiles.vue?vue&type=script&lang=js"
export * from "./DropFiles.vue?vue&type=script&lang=js"
import style0 from "./DropFiles.vue?vue&type=style&index=0&id=88fb3e44&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88fb3e44",
  null
  
)

export default component.exports